import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import template from './thumbnails.jsx';
import displayNames from '../displayNames';
import thumbnail from '../thumbnail/thumbnail';
import addThumbnailButton from '../addThumbnailButton/addThumbnailButton';
import noneThumbnailSymbol from '../icons/thumb-none.svg.js';

var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (!_.isEmpty(props[propName]) && !_.isEmpty(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }

  var optionsType = {
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      illustration: PropTypes.object,
      label: PropTypes.string,
      labelType: PropTypes.string,
      shouldTranslate: PropTypes.bool
    }))
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};

var createAddThumbnailItem = function createAddThumbnailItem(props) {
  return /*#__PURE__*/React.createElement(addThumbnailButton, {
    onClick: props.addThumbnailProps.onAddThumbnailClick,
    label: props.addThumbnailProps.label,
    labelType: props.addThumbnailProps.labelType || props.labelsType,
    shouldTranslate: props.addThumbnailProps.shouldTranslate || props.shouldTranslate,
    style: props.addThumbnailProps.height ? {
      height: props.addThumbnailProps.height + 'px'
    } : null,
    isFirst: props.addThumbnailProps.isFirst || false
  });
};

var createThumbnailFromOptions = function createThumbnailFromOptions(thumbnailProps) {
  return /*#__PURE__*/React.createElement(thumbnail, _.assign({
    key: thumbnailProps.value,
    labelType: thumbnailProps.labelType,
    shouldTranslate: thumbnailProps.shouldTranslate
  }, thumbnailProps));
};

var createThumbnailsFromOptions = function createThumbnailsFromOptions(props) {
  var thumbnails = _(props.options).map(function (thumbnailProps) {
    return _.assign({
      labelType: props.labelsType,
      hasBackground: props.hasBackground,
      shouldTranslate: props.shouldTranslate,
      fixedRatio: props.fixedRatio
    }, thumbnailProps);
  }).map(createThumbnailFromOptions).value();

  var addThumbnailProps = props.addThumbnailProps;

  if (addThumbnailProps) {
    var addThumbnail = createAddThumbnailItem(props);
    return addThumbnailProps.isFirst ? [addThumbnail].concat(thumbnails) : thumbnails.concat(addThumbnail);
  }

  return thumbnails;
};

var createNoneThumbnail = function createNoneThumbnail(props) {
  return createThumbnailFromOptions({
    value: props.noneThumbnailProps.value,
    label: props.noneThumbnailProps.label,
    labelType: props.noneThumbnailProps.labelType || props.labelsType,
    illustration: /*#__PURE__*/React.createElement('div', {
      className: 'none-thumbnail-symbol-container',
      style: {
        height: props.noneThumbnailProps.height + 'px'
      }
    }, /*#__PURE__*/React.createElement(noneThumbnailSymbol)),
    shouldTranslate: props.noneThumbnailProps.shouldTranslate || props.shouldTranslate,
    fixedRatio: props.fixedRatio
  });
};

var Thumbnails = /*#__PURE__*/function (_React$Component) {
  _inherits(Thumbnails, _React$Component);

  var _super = _createSuper(Thumbnails);

  function Thumbnails(props) {
    var _this;

    _classCallCheck(this, Thumbnails);

    _this = _super.call(this, props);
    _this.groupId = _.uniqueId('thumbnails');

    _this.generateChildren = function () {
      var noneThumbnails = _this.props.noneThumbnailProps ? createNoneThumbnail(_this.props) : [];
      var children = _this.props.children || createThumbnailsFromOptions(_this.props);
      var shouldAddTooltipOnEllipsis = props.borderType !== 'thumbnailAndLabel' && _this.props.shouldAddTooltipOnEllipsis;

      var childrenWithEllipsisProp = _.map(children, function (child) {
        if (_this.isThumbnail(child)) {
          return /*#__PURE__*/React.cloneElement(child, _.defaults({
            shouldAddTooltipOnEllipsis: shouldAddTooltipOnEllipsis
          }, _objectSpread(_objectSpread({}, child.props), {}, {
            disabled: props.disabled
          })));
        }

        return child;
      });

      return _.concat(noneThumbnails, childrenWithEllipsisProp);
    };

    _this.isThumbnail = function (item) {
      return _.has(item, 'type.getDisplayName') && item.type.getDisplayName() === displayNames.THUMBNAIL;
    };

    _this.getThumbnailWrapperClasses = function (item) {
      return {
        'thumbnail-wrapper': true,
        selected: item.props.disabled ? false : _this.props.value === item.props.value,
        'none-thumbnail': _this.props.noneThumbnailProps && item.props.value === _this.props.noneThumbnailProps.value
      };
    };

    _this.getControlClasses = function () {
      return {
        'is-disabled': _this.isDisabled(),
        'with-border': _this.props.borderType !== 'none',
        'outer-border': _this.props.borderType === 'thumbnailAndLabel',
        'inner-border': _this.props.borderType === 'thumbnail',
        'select-hover-only-border': _this.props.borderModes === 'hoverAndSelect',
        'with-label': _this.props.children ? _.some(_this.props.children, 'props.label') : _.some(_this.props.options, 'label')
      };
    };

    return _this;
  }

  _createClass(Thumbnails, [{
    key: "isDisabled",
    value: function isDisabled() {
      return this.props.disabled === true;
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return Thumbnails;
}(React.Component);

Thumbnails.displayName = 'Thumbnails';
Thumbnails.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: validateOptions,
  maxThumbsPerRow: PropTypes.number,
  labelsType: PropTypes.string,
  fixedRatio: PropTypes.bool,
  shouldAddTooltipOnEllipsis: PropTypes.bool,
  borderType: PropTypes.oneOf(['none', 'thumbnailAndLabel', 'thumbnail']),
  borderModes: PropTypes.oneOf(['default', 'hoverAndSelect']),
  disabled: PropTypes.bool,
  addThumbnailProps: PropTypes.shape({
    onAddThumbnailClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    labelType: PropTypes.string,
    height: PropTypes.number,
    shouldTranslate: PropTypes.bool,
    isFirst: PropTypes.bool
  }),
  hasBackground: PropTypes.bool,
  noneThumbnailProps: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelType: PropTypes.string,
    height: PropTypes.number,
    shouldTranslate: PropTypes.bool
  })
};
Thumbnails.defaultProps = {
  borderType: 'none',
  borderModes: 'default',
  hasBackground: true,
  shouldAddTooltipOnEllipsis: true
};
export default compose(Thumbnails);